import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const OuterWrapper = styled(Box)(`
  width:100%;
  align-self:baseline;
`)
